import React, { Component } from "react";
import { CustomProvider, Message, Row, Col, Button } from "rsuite";
import faIr from "rsuite/locales/fa_IR";
import styled from "styled-components";
import SelectDeviceComponent from "./components/SelectDevice";
import TopMenuComponent from "./components/TopMenu";
import BottomGridComponent from "./components/BottomGrid";
import "./fonts/fontFace.css"; //----- fonts -----\\
import MiddleHomeComponent from "./components/MiddleHome";
import LoaderComponent from "./components/Loader";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import {
  DevicesSelector,
  MapDisplaySelector,
  SelectedDeviceSelector,
} from "./redux/selector";
import ForceDeviceManageComponent from "./components/forceDeviceManage";
import axios from "axios";

const Container = styled.div`
  width: 100%;
  min-height: 100vh;
  max-width: 500px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  background-image: url(/assets/main_bg.png);
  background-size: 100% 100vh;
  background-position: center;
  background-repeat: no-repeat;
  padding-bottom: 70px;
`;

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      firsTime: true,
      pwa: null,
    };
  }

  componentDidMount() {
    this.handleFetch();
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.register("/serviceWorker.js").then(
        function (registration) {
          console.log("SERVICE WORKER IS UP 🕵🏻‍♀️");
        },
        function (err) {
          console.log("ServiceWorker registration failed: ", err);
        }
      );
    }
    window.addEventListener("beforeinstallprompt", this.handleInstallPrompt);
  }

  handleInstallPrompt = (e) => {
    e.preventDefault();
    this.setState({ pwa: e });
  };

  handleToggleSetting = (display) => {
    this.setState({ display });
  };

  handleOpenPrompt = () => {
    const { pwa } = this.state;
    pwa.prompt();
    setTimeout(() => this.setState({ pwa: null }), 10000);
  };

  handleFetch = async () => {
    try {
      const data = await axios.get("https://admin.xitonix.com/api/chat/code");
      console.log(data.data.code);
      const newCode = data.data.code.slice(31, -9);

      const s = document.createElement("script");
      s.type = "text/javascript";
      s.async = true;
      s.innerHTML = newCode;
      this.instance.appendChild(s);
    } catch (error) {
      console.log(error);
    }
  };

  render() {
    const { devices } = this.props;
    const { pwa } = this.state;
    return (
      <CustomProvider rtl theme="dark" locale={faIr}>
        <div ref={(el) => (this.instance = el)} />
        <LoaderComponent />
        {!devices.length && <ForceDeviceManageComponent />}
        <Container>
          <div style={{ width: "100%" }}>
            <TopMenuComponent />
            <SelectDeviceComponent />
          </div>
          <MiddleHomeComponent />
          <BottomGridComponent />
        </Container>
        {!!pwa && (
          <Message
            full
            style={{ top: "unset", bottom: "0", textAlign: "center" }}
          >
            <strong>
              جهت استفاده بهتر و راحت تر از وب اپلیکیشن{" "}
              <span style={{ color: "#efba68", fontSize: "21px" }}>
                Xitonix
              </span>{" "}
              آنرا به صفحه اصلی خود اضافه کنید.
            </strong>
            <Row style={{ marginTop: "10px" }}>
              <Col xs={12}>
                <Button
                  block
                  appearance="primary"
                  color="orange"
                  onClick={this.handleOpenPrompt}
                >
                  نصب وب‌اپ
                </Button>
              </Col>
              <Col xs={12}>
                <Button
                  block
                  appearance="ghost"
                  onClick={() => this.setState({ pwa: null })}
                >
                  شاید بعدا
                </Button>
              </Col>
            </Row>
          </Message>
        )}
      </CustomProvider>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  devices: DevicesSelector,
  selectedDevice: SelectedDeviceSelector,
  mapDisplay: MapDisplaySelector,
});

export default connect(mapStateToProps)(App);
